module.exports = __webpack_public_path__ + "Sans titre-2.png?dcb80b60f2cc2ef42fb22ae892fef6ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Sans titre-2.png
// module id = 117
// module chunks = 0